
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1 -1)","fill":"red","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12 2.4A9.6 9.6 0 112.4 12 9.61 9.61 0 0112 2.4zm0-1.2C6.035 1.2 1.2 6.035 1.2 12c0 5.965 4.835 10.8 10.8 10.8 5.965 0 10.8-4.835 10.8-10.8A10.8 10.8 0 0012 1.2z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M12 14.4a.6.6 0 01-.6-.6V6.6a.6.6 0 011.2 0v7.2a.6.6 0 01-.6.6z"}}),_c('circle',{attrs:{"cx":"12","cy":"16.8","r":"1.2"}})])])
          )
        }
      }
    